
import { Component } from 'react';
import { Button, Container, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import ListBuilder from '../../components/listBuilder';
import allowProffessionsBlackIcon from '../../assets/svg/allow-professions-black.svg';
import addIcon from '../../assets/svg/add-icon.svg';
import editIcon from '../../assets/svg/edit.svg';
import copyIcon from "../../assets/svg/copy-icon.svg";
import deleteIcon from "../../assets/svg/garbage.svg";
import xIcon from '../../assets/svg/x.svg';
import linkIcon from '../../assets/svg/link.svg'
import Isvg from 'react-inlinesvg';
import { updateParamsHelper, getParamsFromURL } from "../../helpers/custom.helper";
import { API_ENDPOINT, JOURNAL_DASHBOARD } from '../../constants';
import PreviewModal from '../../components/previewModal';
import Toggle from '../../components/forms/fields/toggle';
import ListCheckBox from '../../components/forms/fields/listCheckbox';
import ErrorModal from '../../components/errorModal';
import { isClinicAdminChecker } from '../../helpers/journal.helper';

class JournalTemplatesPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            ...props.initialData,
            _isMounted: false,

            // template
            journalFormBuilderAddNewTemplate: false,
            journalFormBuilderEditTemplate: false,
            journalFormBuilderDeleteTemplate: false,
            journalFormBuilder: false,

            // profession
            journalTemplateAllowProfessionsModal: false,
            loadingProfessions: false,
            professionsList: [],
            professionsValues: [],
            formValues: [],

            preview: false,
            total: 0,
            params: {
                entries: 10,
                page: 0,
                sortField: 'tsCreatedAt',
                sortType: -1,
                filter: '',
            },
            filter: null,
            loading: true,
            journalTemplates: [],
            error: null,
            modified: 'Not modified'.translate(this.props.lang),
            journalSSOToken: null,
        };
    }

    getProfessions = async () => {
        if (!this.state._isMounted) return;

        this.setState({
            loadingProfessions: true,
            professionsList: [],
        })

        try {
            const response = await fetch(
                `${API_ENDPOINT}/users/users/patient/journalTemplates/workersCategories/get`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    },
                    body: JSON.stringify({
                        groupId: this.props.selectedGroup || null,
                    }),
                }
            );

            const data = await response.json();

            if (data) {
                const newState = {
                    loadingProfessions: false,
                    professionsList: data,
                };

                this.setState(newState);
            } else {
                const errState = { loadingProfessions: false };
                if (data.error) { errState.error = data.error }

                this.setState(errState);
            }
        } catch (err) {
            this.setState({
                loadingProfessions: false,
                error: err?.message || 'Error fetching professions',
            });
        }
    }

    get = async () => {
        if (!this.state._isMounted) return;

        this.setState({
            loading: true,
            // journalTemplates: [],
            modified: 'Not modified'.translate(this.props.lang),
        });

        try {

            const response = await fetch(
                `${API_ENDPOINT}/users/users/patient/journalTemplates/get`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    },
                    body: JSON.stringify({
                        groupAlias: localStorage.getItem('groupAlias'),
                        groupId: this.props.selectedGroup || null,
                        departmentId: this.props.selectedClinic || null,
                        total: this.state.total,
                        entries: this.state.params?.entries,
                        page: this.state.params?.page,
                        sortField: this.state.params?.sortField,
                        sortType: this.state.params?.sortType,
                        filter: this.state.params?.filter,
                    }),
                }
            );

            const { data } = await response.json();

            if (data?.items) {
                const newState = {
                    loading: false,
                    journalTemplates: data.items,
                    total: data.total,
                };

                if (data.tsModified) {
                    const modified = this.props.getStringDateTs?.(
                        data.tsModified,
                        this.props.dateFormat
                    );
                    if (modified) newState.modified = modified.translate(this.props.lang);
                }

                this.setState(newState);
            } else {
                const errState = {
                    loading: false,
                    modified: 'Not modified'.translate(this.props.lang),
                };

                if (data?.error) {
                    errState.error = data.error;
                }

                this.setState(errState);
            }

        } catch (err) {
            this.setState({
                loading: false,
                error: err?.message || 'Error fetching professions',
            });
        }
    };

    getJournalSSOToken = async (type = "templates") => {
        try {
            const response = await fetch(
                `${API_ENDPOINT}/users/users/patient/journal/getJournalTokenSSO`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                    },
                    body: JSON.stringify({ type, groupId: this.props.selectedGroup || null }),
                }
            );

            const data = await response.json();

            if (!response.ok || data?.error) {
                throw new Error(data?.error || "SSO token error");
            }

            return data;
        } catch (err) {
            console.error("SSO token fetch error", err);
            return null;
        }
    };

    getConnectedForms = async (forms) => {
        if (!forms || Object.keys(forms).length === 0) return;

        try {
            const response = await fetch(
                `${API_ENDPOINT}/users/users/patient/journalTemplates/connectedForms/get`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                    },
                    body: JSON.stringify({ forms, groupId: this.props.selectedGroup || null }),
                }
            );

            const data = await response.json();

            if (!response.ok || data?.error) {
                throw new Error(data?.error || "Connected forms error");
            }

            return data;
        } catch (err) {
            console.error("Connected forms fetch error", err);
            return null;
        }
    }


    copyJournalTemplate = async (id) => {
        if (!id) return;

        try {
            const response = await fetch(
                `${API_ENDPOINT}/users/users/patient/journalTemplates/copy/${id}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                    },
                    body: JSON.stringify({
                        groupId: this.props.selectedGroup || null,
                        departmentId: this.props.selectedClinic || null,
                    }),
                }
            );

            const data = await response.json();

            if (!response.ok || data?.error) {
                throw new Error(data?.error || "Copy template error");
            }

            return data;
        } catch (err) {
            console.error("Copy template fetch error", err);
            return null;
        }
    }

    applyProfessionsToTemplate = async (templateId, professions) => {
        if (!templateId) return;

        try {
            const response = await fetch(
                `${API_ENDPOINT}/users/users/patient/journalTemplates/${templateId}/professions`,
                {
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                    },
                    body: JSON.stringify({
                        groupId: this.props.selectedGroup || null,
                        departmentId: this.props.selectedClinic || null,
                        professions: professions || [],
                    }),
                }
            );

            const data = await response.json();

            if (!response.ok || data?.error) {
                throw new Error(data?.error || "Apply professions error");
            }

            return data;
        } catch (err) {
            console.error("Apply professions fetch error", err);
            return null;
        }
    }

    disconnectFormsFromTemplate = async (templateId, forms) => {
        if (!templateId || !forms || forms.length === 0) return;

        try {
            for (const formId of forms) {
                const res = await fetch(`${API_ENDPOINT}/users/users/patient/journalTemplates/${templateId}/connectedForms/${formId}/disconnect`, {
                    method: 'PATCH',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : '',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        groupId: this.props.selectedGroup,
                        departmentId: this.props.selectedClinic,
                        removeConnectionFromForm: true
                    })
                });

                const data = await res.json();
                if (!res.ok || data?.error) {
                    console.error(`Error disconnecting form ${formId}:`, data?.error || "Unknown error");
                    this.setState({ errorDisconnectingForm: `Error disconnecting form ${formId}` });
                    return null
                }
            }

        } catch (err) {
            console.error("Disconnecting forms error", err);
            this.setState({ errorDisconnectingForm: "Error disconnecting forms!" });
            return null;
        }

        return true;
    }


    deleteJournalTemplate = async (id) => {
        if (!id) return;

        try {
            const response = await fetch(
                `${API_ENDPOINT}/users/users/patient/journalTemplates/${id}`,
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                    },
                    body: JSON.stringify({
                        groupId: this.props.selectedGroup || null,
                        departmentId: this.props.selectedClinic || null,
                    }),
                }
            );

            const data = await response.json();

            if (data?.error) {
                this.setState({ error: data?.error, journalFormBuilderDeleteTemplate: null });
            } else {
                this.get();
                this.setState({
                    journalFormBuilderDeleteTemplate: null,
                });
            }

        } catch (err) {
            console.error("Delete template fetch error", err);
            return null;
        }
    }


    formatFormWayOfSchedulingLabel = (value = "") => {
        return value
            .replace(/([A-Z])/g, " $1")
            .trim()
            .replace(/^./, str => str.toUpperCase());
    };

    componentDidMount() {
        this.state._isMounted = true;

        this.getProfessions();

        window.addEventListener("message", this.handleIframeReady);
        window.addEventListener("message", this.handleIframeCloseModal);

        const urlParams = getParamsFromURL();

        const newParams = {
            ...this.state.params,
            entries: urlParams.entries,
            filter: urlParams.filter,
        };

        this.setState({ params: newParams }, () => {
            if (this.props.journalTemplates) {
                this.setState({
                    loading: false,
                    journalTemplates: this.props.journalTemplates,
                });
            } else {
                // this.setState({loading: false, journalTemplates: [DEFAULT_TEMPLATE_OBJECT_DELETE_LATER]}) // DELETE THIS LATER
                this.get();
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.patientId !== this.props.patientId ||
            prevProps._groupId !== this.props._groupId ||
            prevProps.view !== this.props.view ||
            prevProps.selectedClinic !== this.props.selectedClinic
        ) {
            this.setState({
                loading: true,
                journalTemplates: [],
                modified: 'Not modified'.translate(this.props.lang),
            });

            this.get();
        }
    }

    componentWillUnmount() {
        this.state._isMounted = false;
        window.removeEventListener("message", this.handleIframeReady);
        window.removeEventListener("message", this.handleIframeCloseModal);
    }

    // always copy - paste these updateSort, updateParams, updateMultipleParams
    updateSort = (field, type) => {
        updateParamsHelper(this, { sortField: field, sortType: type });
    };

    updateParams = (name, value, restart = false) => {
        updateParamsHelper(this, { [name]: value }, restart);
    };

    updateMultipleParams = (fields, restart = false) => {
        updateParamsHelper(this, fields, restart);
    };

    handleIframeReady = (event) => {
        // if (event.origin !== JOURNAL_DASHBOARD) return;
        if (!this.state._isMounted) return;

        if (event.data.type === "IFRAME_READY_V1_JOURNAL_TEMPLATES_FORM") {
            const iframe = document.getElementById("journalTemplatesPageIframe");
            if (!iframe || !iframe.contentWindow) return;

            const lang = this.props?.lang || "en";
            const countryTwoLetter = this.props?.countryTwoLetter || localStorage.getItem('countryTwoLetter');
            const clinic = this.props.uData?.clinicGroups?.find(c => c._id === this.props.selectedGroup);
            const department = this.props.selectedClinic;
            const journalClinicId = clinic?.journalCuroflow?.clinicId;
            const journalDoctorId = this.props.uData?.journalCuroflow?.[String(this.props.selectedGroup)]?.id;
            const isAdmin = isClinicAdminChecker(this.props);

            const payload = { type: "APP_DATA", payload: { clinicId: journalClinicId, doctorId: journalDoctorId, departmentId: department, lang: lang, countryTwoLetter: countryTwoLetter, isClinicAdmin: isAdmin } };
            iframe.contentWindow.postMessage(payload, `${JOURNAL_DASHBOARD}`);
        }
    };

    handleIframeCloseModal = (event) => {
        // if (event.origin !== JOURNAL_DASHBOARD) return;
        if (event.data.type === "IFRAME_CLOSE_V1_JOURNAL_TEMPLATES_MODAL") {
            this.closeModal();
            this.get();
        }
    }

    closeModal = () => {
        this.setState({ journalFormBuilderEditTemplate: null })
        this.setState({ journalFormBuilderAddNewTemplate: null })
    }

    renderIframe(id) {
        return (
            <iframe
                id="journalTemplatesPageIframe"
                src={`${JOURNAL_DASHBOARD}/journal/templates/${id}?token=${this.state.journalSSOToken}`}
                // src={`http://localhost:3000/journal/templates/${id}`}
                style={{ width: '100%', height: '70vh', border: '1px solid #fff' }}
            />
        );
    }

    render() {
        let params = this.state.params;

        return (
            <div>
                {/* <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}> */}
                <Container fluid>
                    {/* <Row>
                        <Col lg="12"> */}
                    <div className="panel" style={{ paddingTop: 0 }}>
                        <div className="panel-header">
                            {/* <h5 className="component-header">{'Journal templates'.translate(this.props.lang)}</h5> */}
                            <div></div>
                            <div>
                                <button className="btn add-button" onClick={async () => {
                                    const { data: tokenData } = await this.getJournalSSOToken("templates");
                                    if (!tokenData?.data?.token) return;

                                    this.setState({ journalSSOToken: tokenData.data.token });
                                    this.setState({ journalFormBuilderAddNewTemplate: true });
                                    this.setState({ journalFormBuilderEditTemplate: null });
                                }}>
                                    <Isvg src={addIcon} />
                                    {'Add'.translate(this.props.lang)}
                                </button>
                            </div>
                        </div>

                        {/* Journal Templates List */}
                        <ListBuilder
                            lang={this.props.lang}
                            loading={this.state.loading}
                            total={this.state.total}
                            hideEntries={false}
                            showNumeration={true}
                            fields={[
                                {
                                    type: 'text',
                                    name: 'name',
                                    label: 'Name'.translate(this.props.lang)
                                },
                                // {
                                //     type: 'text',
                                //     name: 'templateType',
                                //     label: 'Template Type'.translate(this.props.lang),
                                // },
                                {
                                    type: 'date',
                                    name: 'createdAt',
                                    label: 'Created at'.translate(this.props.lang)
                                },
                                {
                                    type: 'text',
                                    name: 'isActive',
                                    label: 'Active'.translate(this.props.lang),
                                },
                                {
                                    type: 'text',
                                    name: 'assigned',
                                    label: 'Assigned'.translate(this.props.lang)
                                },
                                {
                                    type: 'date',
                                    name: 'updatedAt',
                                    label: 'Last updated'.translate(this.props.lang)
                                }

                            ]}
                            items={this.state.journalTemplates.map((item) => {
                                return {
                                    ...item,
                                    isActive: <div style={{ height: 33, width: 100, marginTop: -18 }}>
                                        <Toggle value={item.isActive ? item.isActive : false} onChange={async () => {
                                            if ((!item?.professions || item?.professions?.length === 0) && !item.isActive) {
                                                this.setState({
                                                    error: "At least 1 group needs to be selected before you can activate template".translate(this.props.lang)
                                                })
                                                return;
                                            } else {
                                                try {
                                                    const response = await fetch(`${API_ENDPOINT}/users/users/patient/journalTemplates/${item._id}`, {
                                                        method: 'PATCH',
                                                        headers: {
                                                            'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                                                            'Content-Type': 'application/json'
                                                        },
                                                        body: JSON.stringify({
                                                            groupId: this.props.selectedGroup || null,
                                                            departmentId: this.props.selectedClinic || null,
                                                        })
                                                    });

                                                    const data = await response.json();

                                                    if (data.result?.error) {
                                                        this.setState({ error: data.result.error });
                                                    } else {
                                                        this.get();
                                                    }
                                                } catch (err) {
                                                    console.error("Toggle isActive error", err);
                                                }
                                            }


                                        }} />
                                    </div>,
                                    assigned: item && item?.professions ? (this.props.lang === 'en' ? item.assignedProfessionEn : item.assignedProfessionSv) : ''
                                };
                            })}
                            actions={[
                                {
                                    renderComponent: (item) => {
                                        return (
                                            <div className={Object.keys(item?.connectedForms ?? {})?.length > 0 ? "tabel-action-tooltip green-isvg-icon" : 'tabel-action-tooltip'}>
                                                <Isvg src={linkIcon} />
                                                {/* <i className="fa fa-unlink danger-color" /> */}
                                                <div className='chat-icons-tooltip'>
                                                    {'Edit connected forms'.translate(this.props.lang)}
                                                </div>
                                            </div>
                                        );
                                    },
                                    onClick: async (item) => {
                                        const { data: tokenData } = await this.getJournalSSOToken("templates");
                                        if (!tokenData?.data?.token) return;

                                        this.setState({ journalSSOToken: tokenData.data.token });

                                        // fetch connected forms []{id, name, type}
                                        const connectedFormsList = await this.getConnectedForms(item?.connectedForms || {});

                                        this.setState({
                                            connectedFormsDetails: connectedFormsList || [],
                                            journalTemplateEditConnectedFormsModal: item
                                        });
                                    }

                                },

                                {
                                    renderComponent: (item) => {

                                        return (
                                            <div className='tabel-action-tooltip'>
                                                <Isvg src={allowProffessionsBlackIcon} width={24} height={24} />
                                                <div className='chat-icons-tooltip'>
                                                    {'Allow professions'.translate(this.props.lang)}
                                                </div>
                                            </div>
                                        );
                                    },
                                    onClick: async (item) => {
                                        this.setState({
                                            journalTemplateAllowProfessionsModal: item,
                                            professionsValues: item?.professions || []
                                        });
                                    },
                                },
                                {
                                    renderComponent: (item) => {
                                        // const journalDoctorId = this.props.uData?.journalCuroflow?.[String(this.props.selectedGroup)]?.id;
                                        // if(item?.doctorId !== journalDoctorId) return <></>

                                        return (
                                            <div className='tabel-action-tooltip'>
                                                <Isvg src={editIcon} />
                                                <div className='chat-icons-tooltip'>
                                                    {'Edit template'.translate(this.props.lang)}
                                                </div>
                                            </div>
                                        );
                                    },
                                    onClick: async (item) => {
                                        const { data: tokenData } = await this.getJournalSSOToken("templates");
                                        if (!tokenData?.data?.token) return;

                                        this.setState({ journalSSOToken: tokenData.data.token });
                                        this.setState({ journalFormBuilderAddNewTemplate: false });
                                        this.setState({ journalFormBuilderEditTemplate: item });
                                    },
                                },
                                {
                                    renderComponent: (item) => {
                                        return (
                                            <div className='tabel-action-tooltip'>
                                                <Isvg src={copyIcon} />
                                                <div className='chat-icons-tooltip'>
                                                    {'Copy template'.translate(this.props.lang)}
                                                </div>
                                            </div>
                                        );
                                    },
                                    onClick: async (item) => {
                                        const { data: tokenData } = await this.getJournalSSOToken("templates");
                                        if (!tokenData?.data?.token) return;

                                        this.setState({ journalSSOToken: tokenData.data.token });
                                        await this.copyJournalTemplate(item?._id || item?.id);
                                        this.get();
                                    },
                                },
                                {
                                    renderComponent: (item) => {

                                        return (
                                            <div className='tabel-action-tooltip'>
                                                <Isvg src={deleteIcon} />
                                                <div className='chat-icons-tooltip'>
                                                    {'Delete template'.translate(this.props.lang)}
                                                </div>
                                            </div>
                                        );
                                    },
                                    onClick: async (item) => {
                                        const { data: tokenData } = await this.getJournalSSOToken("templates");
                                        if (!tokenData?.data?.token) return;

                                        this.setState({ journalSSOToken: tokenData.data.token });
                                        this.setState({ journalFormBuilderDeleteTemplate: item });
                                    },
                                },
                            ]}

                            rawItems={this.state.items}
                            params={params}
                            sortField={params.sortField}
                            sortType={params.sortType}
                            updateSort={this.updateSort}
                            updateParams={this.updateParams}
                            updateMultipleParams={this.updateMultipleParams}
                        ></ListBuilder>

                        {/* Preview for journal form builder - ADD NEW TEMPLATE */}
                        <PreviewModal
                            lang={this.props.lang}
                            isOpen={this.state.journalFormBuilderAddNewTemplate}
                            toggle={() => this.setState({ journalFormBuilderAddNewTemplate: null })}
                            className={"modal-xxxl"}
                            hideCloseButton={true}
                        >
                            {this.state.journalFormBuilderAddNewTemplate && (
                                this.renderIframe('new')
                            )}
                        </PreviewModal>

                        {/* journalTemplateEditConnectedFormsModal */}
                        {/* <PreviewModal
                            lang={this.props.lang}
                            isOpen={!!this.state.journalTemplateEditConnectedFormsModal}
                            toggle={() => this.setState({ journalTemplateEditConnectedFormsModal: null })}
                            className="modal-lg"
                            beforeCloseButton={
                                this.state.connectedFormsDetails?.length > 0 && (
                                    <Button
                                        color="primary"
                                        onClick={async () => {
                                            const success = await this.disconnectFormsFromTemplate(
                                                this.state.journalTemplateEditConnectedFormsModal?.id,
                                                this.state.formValues
                                            );

                                            if (success) {
                                                this.get();
                                                this.setState({
                                                    journalTemplateEditConnectedFormsModal: null,
                                                    formValues: [],
                                                    connectedFormsDetails: []
                                                });
                                            }
                                        }}
                                    >
                                        {'Save'.translate(this.props.lang)}
                                    </Button>
                                )
                            }
                        >
                            {this.state.connectedFormsDetails?.length > 0 ? (
                                <FormGroup>
                                    <ListCheckBox
                                        label={'Disconnect forms from this journal template:'.translate(this.props.lang)}
                                        value={this.state.formValues}
                                        enableSelectAll={true}
                                        enableDeselectAll={true}
                                        values={this.state.connectedFormsDetails.map((form) => ({
                                            name: form.name || "N/A",
                                            value: form.id
                                        }))}
                                        customColSize="4"
                                        onChange={(selectedIds) => {
                                            this.setState({ formValues: Array.isArray(selectedIds) ? selectedIds : [] });
                                        }}
                                    />
                                </FormGroup>
                            ) : (
                                <p>{("No connected forms available for this template".translate(this.props.lang))}</p>
                            )}
                        </PreviewModal> */}

                        {
                            this.state.journalTemplateEditConnectedFormsModal ?
                                <Modal isOpen={this.state.journalTemplateEditConnectedFormsModal} centered size='lg'>
                                    <ModalHeader close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({
                                        journalTemplateEditConnectedFormsModal: null,
                                        connectedFormsDetails: []
                                    })}><Isvg src={xIcon} /></button>}>{'Connected forms'.translate(this.props.lang)}</ModalHeader>

                                    <ModalBody>
                                        <div style={{ fontSize: 14, marginBottom: 12 }}>
                                            {"The following forms are actively connected to this EHR template. Click the X icon next to a form to disconnect it from this template. To connect a form to this template, go to the form builder page".translate(this.props.lang)}
                                        </div>

                                        <div style={{ display: "grid", gap: 10 }}>
                                            {(this.state.connectedFormsDetails ?? []).map((f) => (
                                                <div
                                                    key={f.id}
                                                    style={{
                                                        border: "1px solid #e5e7eb",
                                                        borderRadius: 8,
                                                        padding: "10px 12px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                    }}
                                                >
                                                    <span>{`${f.name} - ${this.formatFormWayOfSchedulingLabel(f?.wayOfScheduling).translate(this.props.lang)}`}</span>

                                                    <Button
                                                        close
                                                        aria-label={`Disconnect ${f.name} - ${this.formatFormWayOfSchedulingLabel(f?.wayOfScheduling).translate(this.props.lang)}`}
                                                        onClick={async () => {
                                                            const success = await this.disconnectFormsFromTemplate(
                                                                this.state.journalTemplateEditConnectedFormsModal?.id,
                                                                [f.id]
                                                            );

                                                            if (success) {
                                                                this.get();
                                                                this.setState({
                                                                    // journalTemplateEditConnectedFormsModal: null,
                                                                    formValues: [],
                                                                    connectedFormsDetails: [...this.state.connectedFormsDetails?.filter(item => item.id !== f.id)]
                                                                });
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            ))}

                                            {!this.state.connectedFormsDetails?.length && (
                                                <div style={{ fontSize: 13 }}>
                                                    {'No connected forms'.translate(this.props.lang)}
                                                </div>
                                            )}
                                        </div>
                                    </ModalBody>

                                    <div style={{ display: "flex", justifyContent: "space-between", padding: '1rem' }}>
                                        <Button
                                            color="danger"
                                            onClick={async () => {
                                                const success = await this.disconnectFormsFromTemplate(
                                                    this.state.journalTemplateEditConnectedFormsModal?.id,
                                                    [...this.state.connectedFormsDetails?.map(f => f.id)]
                                                );

                                                if (success) {
                                                    this.get();
                                                    this.setState({
                                                        journalTemplateEditConnectedFormsModal: null,
                                                        formValues: [],
                                                        connectedFormsDetails: []
                                                    });
                                                }
                                            }}
                                            disabled={!this.state.connectedFormsDetails?.length}
                                        >
                                            {'Disconnect all forms'.translate(this.props.lang)}
                                        </Button>

                                        <Button color="primary" onClick={() => {
                                            this.setState({
                                                journalTemplateEditConnectedFormsModal: null,
                                                connectedFormsDetails: []
                                            })
                                        }}>
                                            {'Close'.translate(this.props.lang)}
                                        </Button>
                                    </div>
                                </Modal>
                                :
                                null
                        }


                        {/* errorDisconnectingForm */}
                        <PreviewModal
                            lang={this.props.lang}
                            isOpen={!!this.state.errorDisconnectingForm}
                            toggle={() => this.setState({ errorDisconnectingForm: null })}
                            className="modal-lg"
                        >
                            <p>{("Error disconnecting form".translate(this.props.lang))}</p>
                        </PreviewModal>


                        {/* Preview for allow professions */}
                        <PreviewModal
                            lang={this.props.lang}
                            isOpen={this.state.journalTemplateAllowProfessionsModal}
                            toggle={() => this.setState({ journalTemplateAllowProfessionsModal: null })}
                            className={"modal-lg"}
                            beforeCloseButton={<Button
                                color="primary"
                                onClick={async () => {
                                    await this.applyProfessionsToTemplate(
                                        this.state.journalTemplateAllowProfessionsModal?.id,
                                        this.state.professionsValues
                                    );

                                    this.get();
                                    this.setState({
                                        journalTemplateAllowProfessionsModal: null,
                                        professionsValues: []
                                    });
                                }}
                            >
                                {'Save'.translate(this.props.lang)}
                            </Button>}
                        >
                            {this.state.journalTemplateAllowProfessionsModal && (
                                <FormGroup>
                                    <ListCheckBox
                                        label={'Select professions which can use this template:'.translate(this.props.lang)}
                                        value={this.state.professionsValues}
                                        enableSelectAll={true}
                                        lang={this.props.lang}
                                        enableDeselectAll={true}
                                        // buttonText1={'Mark all'.translate(this.props.lang)}
                                        // buttonText2={'Unmark all'.translate(this.props.lang)}
                                        values={this.state.professionsList && this.state.professionsList.length > 0 ? this.state.professionsList.map(item => {
                                            return { name: this.props.lang == 'en' ? item.professionEn : item.professionSv, value: item._id }
                                        }) : null}
                                        customColSize={"4"}
                                        onChange={(e) => {
                                            if (e && e.length) {
                                                let arr = [];
                                                arr = [...e]
                                                this.setState({ professionsValues: arr })
                                            } else {
                                                this.setState({ professionsValues: [] })
                                            }
                                        }}
                                    />


                                </FormGroup>
                            )}
                        </PreviewModal>

                        {/* Preview for journal form builder - EDIT TEMPLATE */}
                        <PreviewModal
                            lang={this.props.lang}
                            isOpen={this.state.journalFormBuilderEditTemplate}
                            toggle={() => this.setState({ journalFormBuilderEditTemplate: null })}
                            className={"modal-xxxl"}
                            hideCloseButton={true}
                        >
                            {this.state.journalFormBuilderEditTemplate && (
                                this.renderIframe(this.state.journalFormBuilderEditTemplate?._id)
                            )}
                        </PreviewModal>

                        {/* */}

                        {
                            this.state.journalFormBuilderDeleteTemplate ? <Modal isOpen={this.state.journalFormBuilderDeleteTemplate} centered toggle={() => this.setState({ journalFormBuilderDeleteTemplate: null })}>
                                <ModalBody className="delete-modal">
                                    <p className="message">{`Are you sure you want to delete this template?`.translate(this.props.lang)}</p>
                                </ModalBody>

                                <ModalFooter className='buttons-right-blue'>
                                    <button style={{ visibility: 'hidden', display: 'none' }} aria-hidden='true'></button>
                                    {/* <Button style={{ minWidth: 100 }} color='danger' onClick={() => this.deleteSelectedInvoice(this.state.deleteInvoice)}>{'Delete'.translate(this.props.lang)}</Button>
                                    <Button style={{ minWidth: 100 }} color='primary' onClick={() => this.setState({ deleteInvoice: null })}>{'Close'.translate(this.props.lang)}</Button> */}
                                    <Button style={{ minWidth: 100 }} color='danger' onClick={async () => await this.deleteJournalTemplate(this.state.journalFormBuilderDeleteTemplate?._id)}>{'Delete'.translate(this.props.lang)}</Button>
                                    <Button style={{ minWidth: 100 }} color='primary' onClick={() => this.setState({ journalFormBuilderDeleteTemplate: null })}>{'Close'.translate(this.props.lang)}</Button>
                                </ModalFooter>
                            </Modal> : null
                        }

                    </div>
                    {/* </Col>
                    </Row> */}
                </Container>
                {/* </div > */}
                {
                    this.state.error ?
                        <ErrorModal
                            isOpen={this.state.error ? true : false}
                            toggle={() => this.setState({ error: null })}
                        >
                            {
                                this.state.error.translate(this.props.lang)
                            }
                        </ErrorModal>
                        :
                        null
                }
            </div>
        );
    }
}

// export default Page(JournalTemplatesPage);
export default JournalTemplatesPage;